import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'

export const TaxContext = React.createContext()

export const TaxConsumer = TaxContext.Consumer

export function TaxProvider(props) {
  const [loaded, setLoaded] = React.useState(false)
  const [taxs, setTaxs] = React.useState([])
  React.useEffect(() => {
    if (!loaded) load()
  })

  const load = (force = false) => {
    if (loaded && !force) return

    fetchQuery(graphql`
      query TaxContextQuery {
        taxs(orderBy: [code], order: ASC) {
          edges {
            node {
              ... TaxSelect_tax @relay(mask: false)
            }
          }
        }
      }
    `)
      .then(({ taxs }) => {
        setLoaded(true)
        setTaxs(taxs.edges.map(({ node }) => node))
      })
      .catch(err => console.error('TaxContext', err.message))
  }

  return (
    <TaxContext.Provider value={{ loaded, taxs, loadTaxs: load }}>
      {props.children}
    </TaxContext.Provider>
  )
}

export default TaxContext
